// Centralised business data for Tuncay Ticaret
export const BUSINESS = {
  name: "Tuncay Ticaret",
  tagline: "Hırdavat & Geri Dönüşüm",
  city: "Kilis / Merkez",
  address:
    "Yavuz Sultan Selim Mah., Güveniş Sk., 79000 Kilis Merkez / Kilis",
  // Phone numbers - displayed in TR format, dialed in international format
  phones: [
    {
      display: "0544 179 20 08",
      tel: "+905441792008",
      whatsapp: "905441792008",
      label: "Hat 1",
    },
    {
      display: "0546 770 68 79",
      tel: "+905467706879",
      whatsapp: "905467706879",
      label: "Hat 2",
    },
  ],
  mapsEmbed:
    "https://www.google.com/maps?cid=11298580980635175338&hl=tr&output=embed",
  mapsLink:
    "https://www.google.com/maps?cid=11298580980635175338",
};

export const WA_DEFAULT_MSG =
  "Merhaba, Tuncay Ticaret web sitesi üzerinden ulaşıyorum. Bilgi almak istiyorum.";
